export default [
  {
    path: '/admin/report/daily-item-used-reports',
    name: 'daily-item-used-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/daily-item-used.vue')
  },
  {
    path: '/admin/report/daily-task-updates',
    name: 'daily-task-update',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/daily-task-update.vue')
  },
  {
    path: '/admin/report/detail-projects',
    name: 'detail-projects',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/detail-project.vue')
  },
  {
    path: '/admin/report/site-checkin-out',
    name: 'site-checkinout',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/site-checkin-out.vue')
  },
  {
    path: '/admin/report/performance-report',
    name: 'performance-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/performance.vue')
  },
  {
    path: '/admin/report/borrowing-by-projects',
    name: 'borrowing-by-project',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/project-mgt/borrowing-by-project.vue')
  },
  {
    path: '/admin/report/summary-materials',
    name: 'summary-material',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/summary-material.vue')
  },
  {
    path: '/admin/report/project-lists',
    name: 'project-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/project-mgt/project-list.vue')
  },
  {
    path: '/admin/report/material-clearance-by-projects',
    name: 'material-clearance-by-project',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/project-mgt/material-clearance-by-project.vue')
  },
  {
    path: '/admin/report/project-progression-reports',
    name: 'project-progression-report',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/project-mgt/project-progression-report.vue')
  },
  {
    path: '/admin/report/summary-project-progression-reports',
    name: 'summary-project-progression-report',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/project-mgt/summary-project-progression-report.vue')
  }
]
